module.exports = __webpack_public_path__ + "static/media/doctor_explain.3d86a312.jpg";